var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-base',[_c('b-container',{staticClass:"m-layout-content",attrs:{"fluid":_vm.fluid}},[_c('b-row',{staticStyle:{"margin-right":"0"}},[_c('b-col',{staticStyle:{"padding-right":"0"}},[_vm._t("default")],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36e0cac4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/MContent.vue
// module id = null
// module chunks = 